import React from "react";

import { AudioControl } from "../AudioControl";
import { formatTime } from "../../../../../generics/time-formatting";
import LoadingIndicator from "../../../../Atoms/LoadingIndicator/LoadingIndicator";
import {
  PauseIcon,
  PlayIcon,
  SkipIcon,
  MuteIcon,
  VolumeLowIcon,
  VolumeHighIcon,
} from "assets";

import "./AudioControls.scss";

export interface IAudioControlsProps {
  isPlayed: boolean;
  isMuted: boolean;
  duration: number;
  currentTime: number;
  onPlay: () => Promise<void>;
  onNext?: () => void;
  onPause: () => Promise<void>;
  onVolumeUp: () => void;
  onVolumeDown: () => void;
  onMuteToggle: () => void;
  isLoading: boolean;
}

export const AudioControls: React.FC<
  React.PropsWithChildren<IAudioControlsProps>
> = (props) => {
  const {
    duration,
    currentTime,
    onPlay,
    isPlayed,
    onNext,
    onPause,
    onVolumeUp,
    onVolumeDown,
    onMuteToggle,
    isMuted,
    isLoading,
  } = props;

  const playToggler = isPlayed ? (
    <AudioControl
      onClick={onPause}
      svgIcon={<PauseIcon />}
      ariaLabel="Pause audio"
    />
  ) : (
    <AudioControl
      onClick={onPlay}
      svgIcon={<PlayIcon />}
      ariaLabel="Play audio"
    />
  );

  const muteIcon = isMuted ? <MuteIcon /> : <VolumeHighIcon />;

  return (
    <div className="c-audio-controls">
      {playToggler}
      {onNext && (
        <AudioControl
          onClick={onNext}
          svgIcon={<SkipIcon />}
          ariaLabel="Skip audio"
        />
      )}
      <span className="c-audio-controls__time">
        {formatTime(currentTime, ".")}/{formatTime(duration, ".")}
        {isLoading && (
          <span className="c-audio-controls__loading">
            <LoadingIndicator variant="secondary" />
          </span>
        )}
      </span>
      <AudioControl
        onClick={onMuteToggle}
        svgIcon={muteIcon}
        ariaLabel="Toggle mute"
      />
      <AudioControl
        onClick={onVolumeDown}
        svgIcon={<VolumeLowIcon />}
        ariaLabel="Volume down"
      />
      <AudioControl
        onClick={onVolumeUp}
        svgIcon={<VolumeHighIcon />}
        ariaLabel="Volume up"
      />
    </div>
  );
};
